import { Preview } from "../types";
import api from "./api";

export async function getPreviews(
  documentId: string,
  startIndex: number = 0,
  endIndex: number = 50
) {
  const response = await api.get<Preview[]>(
    `/documents/${documentId}/previews?start_index=${startIndex}&end_index=${endIndex}`
  );
  return response.data;
}

export function cached<T extends any[], RT>(
  asyncFunction: (...args: T) => Promise<RT>
) {
  return async function (...args: T): Promise<RT> {
    // Stringify the arguments to use as a key for caching
    const key = JSON.stringify(args);

    // Check if the result is already in sessionStorage
    const cachedResult = sessionStorage.getItem(key);
    if (cachedResult) {
      // Parse and return the cached result
      return JSON.parse(cachedResult);
    }

    // If not cached, call the original async function
    const result = await asyncFunction(...args);

    // Store the result in sessionStorage
    sessionStorage.setItem(key, JSON.stringify(result));

    return result;
  };
}
